import { Employee, NavigationRoute } from "../types";
import { Announcement, AppLink } from "../types/announcements";

export enum ActionType {
    SetFetchingData = "SET_FETCHING_DATA",
    SetShowFullMenu = "SET_SHOW_FULL_MENU",
    SetCurrentPage = "SET_CURRENT_PAGE",
    SetUserNavLinks = "SET_NAV_LINKS",
    SetUserInfo = "SET_USER_INFO",
    SetUserLinks = "SET_USER_LINKS",
    SetConfigLink = "SET_CONFIG_LINK",
    SetActivePage = "SET_ACTIVE_PAGE",
    SetAnnouncements = "SET_ANNOUNCEMENTS",
    SetSelectedAnncmnt = "SET_SELECTED_ANNCMNT",
    SetAppLink = "SET_APP_LINK",
}

interface ISetFetchingData {
    type: ActionType.SetFetchingData;
    payload: boolean;
}

interface ISetShowFullMenu {
    type: ActionType.SetShowFullMenu;
    payload: boolean;
}

interface ISetCurrentPage {
    type: ActionType.SetCurrentPage;
    payload: any;
}

interface IsetUserNavLinks {
    type: ActionType.SetUserNavLinks;
    payload: NavigationRoute[];
}

interface ISetUserInfo {
    type: ActionType.SetUserInfo;
    payload: Employee;
}

interface IFormLinks {
    type: ActionType.SetUserLinks;
    payload: NavigationRoute[];
}

interface ISetConfigLink {
    type: ActionType.SetConfigLink;
    payload: string;
}

interface ISetActivePage {
    type: ActionType.SetActivePage;
    payload: string;
}

interface ISetAnnouncements {
    type: ActionType.SetAnnouncements;
    payload: Announcement[] | null;
}

interface ISetSelectedAnncmnt {
    type: ActionType.SetSelectedAnncmnt;
    payload?: Announcement;
}

interface ISetAppLink {
    type: ActionType.SetAppLink;
    payload?: AppLink;
}

export type Actions =
    | ISetFetchingData
    | ISetShowFullMenu
    | ISetCurrentPage
    | IsetUserNavLinks
    | ISetUserInfo
    | IFormLinks
    | ISetConfigLink
    | ISetActivePage
    | ISetAnnouncements
    | ISetSelectedAnncmnt
    | ISetAppLink;

export const setFetchingData = (response: boolean): ISetFetchingData => ({
    type: ActionType.SetFetchingData,
    payload: response,
});

export const setShowFullMenu = (response: boolean): ISetShowFullMenu => ({
    type: ActionType.SetShowFullMenu,
    payload: response,
});

export const setCurrentPage = (response: any): ISetCurrentPage => ({
    type: ActionType.SetCurrentPage,
    payload: response,
});

export const setUserNavLinks = (response: NavigationRoute[]): IsetUserNavLinks => ({
    type: ActionType.SetUserNavLinks,
    payload: response,
});

export const setUserInfo = (response: Employee): ISetUserInfo => ({
    type: ActionType.SetUserInfo,
    payload: response,
});

export const setFormLinks = (response: NavigationRoute[]): IFormLinks => ({
    type: ActionType.SetUserLinks,
    payload: response,
});

export const setActivePage = (response: string): ISetActivePage => ({
    type: ActionType.SetActivePage,
    payload: response,
});

export const setAnnouncements = (response: Announcement[] | null): ISetAnnouncements => ({
    type: ActionType.SetAnnouncements,
    payload: response,
});

export const setSelectedAnncmnt = (response?: Announcement): ISetSelectedAnncmnt => ({
    type: ActionType.SetSelectedAnncmnt,
    payload: response,
});

export const setAppLink = (response?: AppLink): ISetAppLink => ({
    type: ActionType.SetAppLink,
    payload: response,
});
